import GroupBarWithoutAxis from "./groupBarWithoutAxis.jsx";

export default GroupBarWithoutAxis;



// WEBPACK FOOTER //
// ./src/components/d3Components/groupBarWithoutAxis/index.js